import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { CalendarSearch, Minus, Plus } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr, inr } from "@/lib/api";

export function BlogBookingBox({ testid = "blog-book", compact = false }) {
  const nav = useNavigate();
  const [safaris, setSafaris] = useState([]);
  const [safariId, setSafariId] = useState("");
  const [date, setDate] = useState("");
  const [guests, setGuests] = useState(2);
  const [slots, setSlots] = useState(null);
  useEffect(() => {
    api.get("/safaris").then((r) => {
      const list = r.data.filter((s) => s.booking_mode !== "on_request" && s.pricing_mode === "per_vehicle");
      setSafaris(list); if (list[0]) setSafariId(list[0].id);
    });
  }, []);
  useEffect(() => { setSlots(null); }, [safariId, date]);
  const safari = safaris.find((s) => s.id === safariId);
  const jeeps = Math.max(1, Math.ceil(guests / (safari?.vehicle_capacity || 6)));

  const check = async () => {
    if (!date) return toast.error("Pick a date");
    try { const { data } = await api.get(`/safaris/${safariId}/availability`, { params: { date } }); setSlots(data); }
    catch (e) { toast.error(formatErr(e)); }
  };
  const book = (slot) => nav(`/checkout?${new URLSearchParams({ safari_id: safariId, slot_id: slot.id, booking_type: "private", vehicles: String(jeeps), adults: String(guests), children: "0" })}`);
  const cls = "h-10 w-full rounded-md border border-[#E2DACF] bg-white px-3 text-sm";

  return (
    <div className={`rounded-2xl bg-white ring-1 ring-black/5 p-5 ${compact ? "" : "md:p-6"}`} data-testid={testid}>
      <div className="flex items-center gap-2 text-[#1E3A2B] mb-1"><CalendarSearch size={18}/><span className="font-serif text-lg">Check availability</span></div>
      <p className="text-xs text-[#5C6B63] mb-4">Private jeep · up to 6 guests per jeep</p>
      <div className={`grid gap-3 ${compact ? "" : "md:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)_minmax(0,1fr)_auto] md:items-end"}`}>
        <select className={cls} value={safariId} onChange={(e) => setSafariId(e.target.value)} data-testid={`${testid}-safari`} aria-label="Safari">
          {safaris.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select>
        <input type="date" className={cls} min={format(new Date(), "yyyy-MM-dd")} value={date} onChange={(e) => setDate(e.target.value)} data-testid={`${testid}-date`} aria-label="Date"/>
        <div className="flex items-center justify-between h-10 rounded-md border border-[#E2DACF] px-2 text-sm">
          <button type="button" onClick={() => setGuests(Math.max(1, guests - 1))} aria-label="Fewer guests" data-testid={`${testid}-minus`}><Minus size={14}/></button>
          <span data-testid={`${testid}-guests`}>{guests} guest{guests > 1 ? "s" : ""}</span>
          <button type="button" onClick={() => setGuests(Math.min(40, guests + 1))} aria-label="More guests" data-testid={`${testid}-plus`}><Plus size={14}/></button>
        </div>
        <button type="button" onClick={check} className="jt-pill-accent justify-center text-sm" data-testid={`${testid}-check`}>Check</button>
      </div>
      {slots && (
        <div className="mt-4 space-y-2" data-testid={`${testid}-results`}>
          {slots.length === 0 && <p className="text-sm text-[#5C6B63]">No departures that day. Try another date or WhatsApp us.</p>}
          {slots.map((s) => {
            const ok = !s.started && s.remaining_vehicles >= jeeps;
            return (
              <div key={s.id} className="flex items-center justify-between gap-3 rounded-xl bg-[#F5F0EB] px-3 py-2 text-sm">
                <div><div className="font-medium">{s.label} · {s.departure_time}</div>
                  <div className="text-xs text-[#5C6B63]">{s.started ? "Safari started" : `${s.remaining_vehicles} jeeps left`} · {inr(s.price * jeeps)} for {jeeps} jeep{jeeps > 1 ? "s" : ""}</div></div>
                <button disabled={!ok} onClick={() => book(s)} className="jt-pill-primary text-xs disabled:opacity-40" data-testid={`${testid}-slot-${s.departure_time}`}>{ok ? "Book" : "Full"}</button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
